const store = {
    namespaced: true,
    state() {
        return {
            isModalShareOpened: false
        };
    },
    getters: {
        getIsModalShareOpened(state) {
            return state.isModalShareOpened;
        }
    },
    mutations: {
        SET_IS_MODAL_SHARE_OPENED(state, value) {
            state.isModalShareOpened = value;
        }
    }
};

export default store;
